import { render, staticRenderFns } from "./HealthProgramsSwiper.vue?vue&type=template&id=c4b0dd88&scoped=true&"
import script from "./HealthProgramsSwiper.vue?vue&type=script&lang=ts&"
export * from "./HealthProgramsSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./HealthProgramsSwiper.vue?vue&type=style&index=0&id=c4b0dd88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b0dd88",
  null
  
)

export default component.exports